export const colorList = {
  'MeshBasicMaterial': {
    colors: {},
    options: {}
  },
  'MeshStandardMaterial': {
    colors: {},
    options: {
      metalness: 0.5,
      roughness: 1
    }
  }
}